export default {
  'app.docs.components.icon.search.placeholder': '在此搜索图标，点击图标可复制代码',
  'app.docs.components.icon.outlined': '线框风格',
  'app.docs.components.icon.filled': '实底风格',
  'app.docs.components.icon.two-tone': '双色风格',
  'app.docs.components.icon.category.direction': '方向性图标',
  'app.docs.components.icon.category.suggestion': '提示建议性图标',
  'app.docs.components.icon.category.editor': '编辑类图标',
  'app.docs.components.icon.category.data': '数据类图标',
  'app.docs.components.icon.category.other': '网站通用图标',
  'app.docs.components.icon.category.logo': '品牌和标识',
  'app.docs.components.icon.pic-searcher.intro': 'AI 截图搜索上线了，快来体验吧！🎉',
  'app.docs.components.icon.pic-searcher.title': '上传图片搜索图标',
  'app.docs.components.icon.pic-searcher.upload-text': '点击/拖拽/粘贴上传图片',
  'app.docs.components.icon.pic-searcher.upload-hint':
    '我们会通过上传的图片进行匹配，得到最相似的图标',
  'app.docs.components.icon.pic-searcher.server-error': '识别服务暂不可用',
  'app.docs.components.icon.pic-searcher.matching': '匹配中...',
  'app.docs.components.icon.pic-searcher.modelloading': '神经网络模型加载中...',
  'app.docs.components.icon.pic-searcher.result-tip': '为您匹配到以下图标：',
  'app.docs.components.icon.pic-searcher.th-icon': '图标',
  'app.docs.components.icon.pic-searcher.th-score': '匹配度',
};
